import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { orgAdminSidebarInviteButtonClickedEvent, sidebarMenuItemClickedEvent, } from '#pplx/frontend/apps/ask/events/sidebar/analytics.js';
import { ButtonBadge } from '#pplx/frontend/apps/ask/layout-aux/shared/ButtonBadge.js';
import { SidebarFooterButton } from '#pplx/frontend/apps/ask/layout/sidebar/core/shared/SidebarFooterButton.js';
import { useUserOrgData } from '#pplx/frontend/apps/ask/organization/hooks/useUserOrgData.js';
import { useGetSettingsPrefix } from '#pplx/frontend/apps/ask/settings/hooks/useGetSettingsRoute.js';
import { useInstrumentation } from '#pplx/frontend/framework/instrumentation/useInstrumentation.js';
import { $icon } from '#pplx/frontend/icons/icon-sprite.js';
import { useCueImpressionLimit } from '#pplx/frontend/upsells/useCueImpressionLimit.js';
import classNames from 'classnames';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';
export const SidebarInviteButton = ({ variant = 'sidebar', }) => {
    const { $t } = useIntl();
    const settingsPrefix = useGetSettingsPrefix();
    const { organization } = useUserOrgData({ reason: 'sidebar-invite-button' });
    const { track } = useInstrumentation();
    const isNewOrg = useMemo(() => {
        const createdDate = organization?.created;
        if (!createdDate)
            return false;
        const thirtyDaysAgo = Date.now() - 30 * 24 * 60 * 60 * 1000;
        return new Date(createdDate).getTime() > thirtyDaysAgo;
    }, [organization?.created]);
    const { shouldShow } = useCueImpressionLimit({
        cueKey: 'sidebar-invite-badge',
        impressionsLimit: 10,
        enabled: isNewOrg,
    });
    const showNotificationBadge = isNewOrg && shouldShow;
    return (_jsxs("div", { className: classNames('relative inline-flex', {
            'h-full items-center justify-center': variant === 'accessory',
        }), children: [_jsx(SidebarFooterButton, { icon: $icon('user-plus'), href: `${settingsPrefix}/org/members`, ariaLabel: $t({
                    defaultMessage: 'Invite team members',
                    description: 'Tooltip for the invite team members button in the sidebar',
                    id: 'f88aa1b3bd',
                }), variant: variant, tooltipSide: "right", tooltipOffsetPx: variant === 'accessory' ? 8 : 18, onTrackEvent: () => {
                    track(orgAdminSidebarInviteButtonClickedEvent);
                    track(sidebarMenuItemClickedEvent({
                        name: 'sidebar menu item clicked',
                        data: {
                            tabType: 'org invite',
                            location: 'sidebar',
                        },
                    }));
                } }), _jsx(ButtonBadge, { visible: showNotificationBadge, variant: variant, "data-testid": "notification-badge" })] }));
};
//# sourceMappingURL=SidebarInviteButton.js.map